import * as $ from "jquery"
import CookieBox from 'cookie-consent-box';

const init = ()=> {
    
    var cookieBox = new CookieBox({ 
        backgroundColor: "rgba(255, 255, 255, 0.88)",
        textColor: "#252525",
        content: {
            title: "Cookies policy",
            content: "Our websites use cookies to monitor your browsing preferences, so we can show content relevant to you based on these preferences.",
            accept: "Accept all cookies"
        }
    });

    cookieBox.init();

    $(".cookie-box").append(`<a class='cookie-box__close' href='#'>×</a>`);

    $(document).on("click", ".cookie-box__close", (ev) => {
        ev.preventDefault();
        cookieBox.hide();
    });
	
}

export const cookieConsentJs = {
	init: init
};